import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Avatar,
  Stack,
  MenuItem,
  Menu,
  ListItemIcon,
  Grid,
  Popover,
  Card,
  Divider,
  Modal,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Dashboard } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  border: "none",
  borderRadius: 4,
};

const Navbar2 = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const [selectLabel, setSelectLabel] = useState("");
  const [openLogout, setOpenLogout] = useState(false);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setOpenLogout(false);
  };

  // useEffect(() => {
  //   if (sessionStorage.getItem("custaccuont") == null) {
  //     navigate("/");
  //   }
  // }, []);

  return (
    <>
      <AppBar
        position='static'
        sx={{
          backgroundColor: "white",
          boxShadow: "none",
          borderBottom: "1px solid #f0f0f0",
          px: 4,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: 64,
          }}
        >
          {/* Left Section */}
          <Box display='flex' alignItems='center' gap={5}>
            <Typography
              variant='h5'
              sx={{
                color: "#144FEE",
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {sessionStorage.getItem("comp_name")}
            </Typography>

            {/* Menu Items */}
            <Stack direction='row' spacing={4}>
              <Box
                display='flex'
                alignItems='center'
                gap={1}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/Home");
                }}
              >
                {/* <Box
                  component='img'
                  src={home} // <-- Replace with your image path
                  alt='home'
                  sx={{
                    width: 15,
                    height: 15,
                    objectFit: "contain",
                    opacity: 0.7, // similar to MUI action color
                  }}
                /> */}

                {/* <HomeOutlinedIcon sx={{ color: "#2e2e2e" }} /> */}

                <Typography
                  variant='body2'
                  sx={{
                    color: "#2e2e2e",
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Home
                </Typography>
              </Box>

              <Box
                display='flex'
                alignItems='center'
                gap={1}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/MachineList");
                }}
              >
                {/* <Box
                  component='img'
                  src={menu} // <-- Replace with your image path
                  alt='home'
                  sx={{
                    width: 15,
                    height: 15,
                    objectFit: "contain",
                    opacity: 0.7, // similar to MUI action color
                  }}
                /> */}
                <Typography
                  variant='body2'
                  sx={{
                    color: "#2e2e2e",
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Machine List
                </Typography>
              </Box>

              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPaper-root": {
                    borderRadius: "2px",
                    mt: 1,
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                    minWidth: 220,
                    p: 1,
                  },
                }}
                onMouseOut={() => {
                  setSelectLabel("");
                }}
              >
                {[
                  {
                    icon: Dashboard,
                    label: "Dashboard",
                    path: "Dashboard",
                    // blue: dash_blue,
                  },
                ].map((item, index) => (
                  <Grid
                    onMouseEnter={() => {
                      setSelectLabel(item.label);
                    }}
                    key={index}
                    onClick={() => {
                      navigate(`/${item.path}`);
                      sessionStorage.setItem("selectnav1", item.label);
                    }}
                    sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: 14,
                      padding: 1,
                      display: "flex",
                      alignItems: "center",
                      "&:hover": {
                        bgcolor: "#F4F8FF",
                        color: "#0D6EFD",
                        fontWeight: 600,
                        cursor: "pointer",
                      },
                    }}
                  >
                    {/* 🔹 Image instead of MUI Icon */}

                    {/* <Box
                      component='img'
                      src={item.label == selectLabel ? item.blue : item.icon} // <--- HERE
                      alt={item.label}
                      sx={{
                        width: 30,
                        height: 30,
                        mr: 1.5,
                        objectFit: "contain",
                      }}
                    /> */}

                    <Dashboard sx={{ mr: 1.5 }} />

                    {item.label}
                  </Grid>
                ))}
              </Menu>

              <Box
                display='flex'
                alignItems='center'
                gap={1}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/ContactUs");
                  sessionStorage.setItem("selectnav1", "Contact us");
                }}
              >
                {/* <Box
                  component='img'
                  src={contact} // <-- Replace with your image path
                  alt='home'
                  sx={{
                    width: 15,
                    height: 15,
                    objectFit: "contain",
                    opacity: 0.7, // similar to MUI action color
                  }}
                /> */}
                <Typography
                  variant='body2'
                  sx={{
                    color: "#2e2e2e",
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Contact
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* Right Section */}
          <Stack direction='row' alignItems='center' spacing={2}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                bgcolor: "#DBEAFE",
                padding: 0.9,
                borderRadius: "8px",
              }}
            >
              <Avatar
                sx={{
                  width: 24,
                  height: 24,
                  bgcolor: "#144FEE",
                  fontSize: 14,
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                I
              </Avatar>
              <Typography
                sx={{
                  color: "#144FEE",
                  fontWeight: 500,
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "0.9rem",
                }}
              >
                {sessionStorage.getItem("comp_name")}
              </Typography>
            </Box>

            <Button
              variant='contained'
              sx={{
                borderRadius: "8px",
                fontFamily: "Poppins, sans-serif",
                textTransform: "none",
                bgcolor: "#144FEE",
                boxShadow: "none",
                fontSize: "0.9rem",
                "&:hover": { bgcolor: "#0B5ED7" },
              }}
              onClick={() => {
                setOpenLogout(true);
              }}
            >
              Sign Out
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>

      <div>
        <Modal
          open={openLogout}
          onClose={handleClose}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <Box sx={style}>
            <Grid
              sx={{
                position: "absolute", // 👈 stays fixed on screen
                top: 10,
                right: 10,
                cursor: "pointer",
                zIndex: 1000, // ensures it stays above other elements
              }}
            >
              <IconButton
                onClick={() => {
                  setOpenLogout(false);
                }}
              >
                <CloseIcon sx={{ color: "#2e2e2e", fontSize: "1.3rem" }} />
              </IconButton>
            </Grid>

            <Grid sx={{ display: "flex", justifyContent: "center" }}>
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 550,
                  fontSize: "1.2rem",
                  color: "#2e2e2e",
                  fontFamily: "Poppins, sans-serif",
                  textAlign: "center",
                }}
              >
                Are You Sure You Want Logout ?
              </Typography>
            </Grid>

            {/* Description Grid */}
            <Grid sx={{ marginTop: 2 }}>
              <Grid sx={{ display: "flex", gap: 3, justifyContent: "center" }}>
                <Button
                  variant='contained'
                  sx={{
                    borderRadius: "8px",
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    bgcolor: "#144FEE",
                    boxShadow: "none",
                    fontSize: "0.9rem",
                    "&:hover": { bgcolor: "#0B5ED7" },
                  }}
                  onClick={() => {
                    setOpenLogout(false);
                  }}
                >
                  No
                </Button>

                <Button
                  variant='contained'
                  sx={{
                    borderRadius: "8px",
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    bgcolor: "#144FEE",
                    boxShadow: "none",
                    fontSize: "0.9rem",
                    "&:hover": { bgcolor: "#0B5ED7" },
                  }}
                  onClick={() => {
                    navigate("/");
                    sessionStorage.clear();
                  }}
                >
                  Yes
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default Navbar2;
